import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { CreditPurchaseView } from "./CreditPurchaseView";
import { CreditPurchaseViewStore } from "../../store/CreditPurchaseViewStore";
import { useStore } from "../../../../hooks";

export const CreditPurchaseViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/creditPurchase/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CreditPurchaseViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <CreditPurchaseView creditPurchaseViewStore={store} />
      </PageLayout>
    </div>
  );
});
